import * as React from 'react';

import {Actions} from './Actions.story';
import {Basic} from './Basic.story';
import {Dismiss} from './Dismiss.story';

const actions = {
  rendered: <Actions />,
  source: `  <Banner
  type="default"
  title="Check your bank details"
  description="Your bank account information must be verified before receiving payouts."
  actions={
    <Button onPress={() => console.log('hello world')}>
      Update bank account
    </Button>
  }
/>`,
};

const basic = {
  rendered: <Basic />,
  source: `<Banner
  type="default"
  onDismiss={() => console.log('hello world')}
  title="Neutral title"
  description="A short description"
  actions={
    <Button onPress={() => console.log('hello world')}>Button</Button>
  }
/>
<Banner
  type="caution"
  title="Check your bank details"
  description="Your bank account information must be verified before receiving payouts."
  onDismiss={() => console.log('hello world')}
  actions={
    <>
      <Button onPress={() => console.log('hello world')}>Update bank account</Button>
      <Button onPress={() => console.log('hello world')}>
        Learn more
      </Button>
    </>
  }
/>
<Banner
  type="critical"
  title="Check your bank details"
  description="Your bank account information must be verified before receiving payouts."
  actions={
    <Button onPress={() => console.log('hello world')}>Update bank account</Button>
  }
/>`,
};

const dismiss = {
  rendered: <Dismiss />,
  source: `const [open, setOpen] = React.useState(true);
return (
  <Button onPress={() => setOpen(!open)}>
    {open ? 'Hide' : 'Show'} Banner
  </Button>
  {open && (
    <Banner
      type="default"
      onDismiss={() => setOpen(false)}
      title="Neutral title"
      description="A short description"
      actions={
        <Button onPress={() => console.log('hello world')}>Button</Button>
      }
    />
  )}
);`,
};

export const BannerExamples = {
  actions,
  basic,
  dismiss,
};
